import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

import Button from 'ui-lib/components/Button';
import Link from 'ui-lib/components/Link';
import FormikTextField from 'ui-lib/components/Inputs/TextField/FormikTextField';
import AuthLayout from 'web-shared/modules/auth/shared/components/AuthLayout';

import { forgotPasswordFieldNameGenerator } from './const';
import ForgotPasswordPageFormikWrapper from './components/ForgotPasswordPageFormikWrapper';

const { n } = forgotPasswordFieldNameGenerator;

const ForgotPasswordPage = () => {
  const { t } = useTranslation();

  return (
    <ForgotPasswordPageFormikWrapper>
      {({ handleSubmit, isValid, isSubmitting }) => (
        <AuthLayout
          onSubmit={handleSubmit}
          title={t('auth.title_resetPassword')}
          subtitle={t('auth.description_resetPassword')}
        >
          {() => (
            <>
              <FormikTextField
                type='email'
                label={t('auth.label_email')}
                name={n('email')}
                disabled={isSubmitting}
                fullWidth
                required
                testID='email'
              />
              <Stack spacing={1.5}>
                <Button
                  fullWidth
                  type='submit'
                  variant='contained'
                  size='large'
                  disabled={!isValid || isSubmitting}
                  loading={isSubmitting}
                  testID='reset-password-button'
                >
                  {t('auth.label_resetPassword')}
                </Button>
                <Link to='/sign-in'>
                  <Button
                    fullWidth
                    type='button'
                    size='large'
                    variant='tonal'
                    testID='back-to-login-button'
                  >
                    {t('auth.label_backToLogin')}
                  </Button>
                </Link>
              </Stack>
            </>
          )}
        </AuthLayout>
      )}
    </ForgotPasswordPageFormikWrapper>
  );
};

export default ForgotPasswordPage;
